import type { ReactNode } from 'react';
import { APP_SCALE, SurfaceScaleContext } from '@/lib/appSurface';

/**
 * Marks a route as the creator's app, so it renders at 90 % (src/lib/appSurface.ts).
 * `display: contents` gives the mark no box: the layout stays the page's own.
 */
export function AppSurface({ children }: { children: ReactNode }) {
  return (
    <SurfaceScaleContext.Provider value={APP_SCALE}>
      <div data-surface="app" className="contents">
        {children}
      </div>
    </SurfaceScaleContext.Provider>
  );
}

export default AppSurface;
